/**
 * OrbDocTutorialsAdvancedAiGenerationAROrbDocTutorialsAdvancedAiGenerationARPage
 *
 * Page component for OrbDocTutorialsAdvancedAiGenerationAROrbDocTutorialsAdvancedAiGenerationARPage
 * Path: /ar/docs/tutorials/advanced/ai-generation
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocTutorialsAdvancedAiGenerationARDocScreenView as __OrbDocTutorialsAdvancedAiGenerationARDocScreenView } from '@/components/traits/OrbDocTutorialsAdvancedAiGenerationARDocScreenView';
import { OrbDocTutorialsAdvancedAiGenerationARDocAnalyticsView as __OrbDocTutorialsAdvancedAiGenerationARDocAnalyticsView } from '@/components/traits/OrbDocTutorialsAdvancedAiGenerationARDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocTutorialsAdvancedAiGenerationAROrbDocTutorialsAdvancedAiGenerationARPageProps {
  // Add any page-level props here
}

export function OrbDocTutorialsAdvancedAiGenerationAROrbDocTutorialsAdvancedAiGenerationARPage(_props: OrbDocTutorialsAdvancedAiGenerationAROrbDocTutorialsAdvancedAiGenerationARPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"توليد البرامج بالذكاء الاصطناعي","description":"صِف تطبيقًا بالكلمات ودع وكيل orb يكتب البرنامج، والمترجم يتحقق من كل خطوة.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/tutorials/advanced/ai-generation"},{"locale":"ar","path":"/ar/docs/tutorials/advanced/ai-generation"},{"locale":"sl","path":"/sl/docs/tutorials/advanced/ai-generation"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocTutorialsAdvancedAiGenerationARDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocTutorialsAdvancedAiGenerationARDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocTutorialsAdvancedAiGenerationAROrbDocTutorialsAdvancedAiGenerationARPage;
